<template>
	<header v-bind:class="['header', { landing }]">
		<!-- Redirect back to the landing screen or to the home page -->
		<router-link v-if="authenticated" :to="title ? '/symptom' : '/'" class="nav">
			<NavIcon :color="landing ? 'white' : 'black'"></NavIcon>
		</router-link>
		<HeaderIcon v-if="landing" class="icon"></HeaderIcon>
		<span v-bind:class="['title', { 'title-left': !authenticated }]">
				{{ title || 'SYMPTOMS'}}
			</span>
	</header>
</template>

<script>
import { mapState } from 'vuex'

import NavIcon from './icon/Back'
import HeaderIcon from './icon/HeaderIcon'

export default {

	props: {
		landing: {
			type: Boolean
		},
		title: {
			type: String
		}
	},

	computed: {
		...mapState('auth', [
			'authenticated'
		])
	},

	components: {
		NavIcon,
		HeaderIcon
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
